import { render, staticRenderFns } from "./StrategyManager.vue?vue&type=template&id=50613418&scoped=true&"
import script from "./StrategyManager.vue?vue&type=script&lang=js&"
export * from "./StrategyManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50613418",
  null
  
)

export default component.exports